/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiLanguage,
    ApiLanguageFromJSON,
    ApiLanguageFromJSONTyped,
    ApiLanguageToJSON,
} from './';

/**
 * request for update assistance request language
 * @export
 * @interface ApiLanguageUpdate
 */
export interface ApiLanguageUpdate {
    /**
     * 
     * @type {ApiLanguage}
     * @memberof ApiLanguageUpdate
     */
    language: ApiLanguage;
}

export function ApiLanguageUpdateFromJSON(json: any): ApiLanguageUpdate {
    return ApiLanguageUpdateFromJSONTyped(json, false);
}

export function ApiLanguageUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiLanguageUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'language': ApiLanguageFromJSON(json['language']),
    };
}

export function ApiLanguageUpdateToJSON(value?: ApiLanguageUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'language': ApiLanguageToJSON(value.language),
    };
}

